import React from 'react';

const Badge = (props) => {
  const { theme, type } = props;

  return (
    <div className="node--sub-heading node--sub-heading--with-labels">
      <div className="theme-label">
        {theme}
      </div>
      <span>{type}</span>
    </div>
  );
};

export default Badge;


